import axios from 'axios';

// The operator console's platform Overview — SUPER_ADMIN only.
//
// One request, not fourteen. §20 of the platform mandate says the console "must not
// be a collection of raw database metrics"; fourteen endpoints returning fourteen
// numbers is exactly that, and the composition — which signals agree, which are
// unmeasured — is the part that is worth showing.
const BASE = '/api/v1.0/admin/console';

const operatorConsoleService = {
  // -> { overallHealth: { status, summary, measuredSignals, unmeasuredSignals },
  //      signals: [ { id, label, status, value, unit, summary, detail } ],
  //      measured, unavailable, note }
  //
  // `status` is one of HEALTHY | DEGRADED | CRITICAL | UNAVAILABLE. UNAVAILABLE is
  // NOT a failure to render — it means the platform is not measuring that signal,
  // and the summary says why. Treating it as an error would hide the finding.
  overview: async () => {
    const res = await axios.get(`${BASE}/overview`);
    return res.data || {};
  },

  // §20.3 — every tenant with its cell, RLS status, migration state and the
  // placement recommendation. Each row also carries `unmeasured`: the §20.3 columns
  // nothing measures per tenant yet, named rather than silently absent, because a
  // column that quietly is not there reads as a column that does not matter.
  placements: async () => (await axios.get(`${BASE}/placements`)).data || {},

  // §20.4 — admission-control load, the workload class table, and an explicit
  // account of which actions do not exist. `runningQueriesAvailable: false` is not a
  // rendering failure: the platform tracks slots, not individual queries, and
  // showing slot counters as a query list would mislead someone trying to stop
  // something.
  queries: async () => (await axios.get(`${BASE}/queries`)).data || {},

  // §20.5 — operations in flight with the transitions each state permits.
  // `confirmationRequired` names the destructive ones; the console should not decide
  // that for itself.
  migrations: async () => (await axios.get(`${BASE}/migrations`)).data || {},

  // §20.6 — desired version (from the migration registry) beside the actual version
  // per cluster. A null actual means the cluster has NEVER been migrated, which is
  // different from version 0 and must not render alike.
  schemas: async () => (await axios.get(`${BASE}/schemas`)).data || {},

  // §20.7 — isolation posture. The per-cluster grant/policy sweep is deliberately
  // NOT run on render; the endpoint for it is returned instead.
  security: async () => (await axios.get(`${BASE}/security`)).data || {},
};

export default operatorConsoleService;
